import { TablePagination as NovaBasePagination } from '@fme-nova/components'
import { default as MuiBasePagination, TablePaginationProps } from '@mui/material/TablePagination'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

const MuiPagination: MsdkStyledComponent<TablePaginationProps> = styled(MuiBasePagination)`
  margin-top: 16px;
  border-bottom: 0;

  .MuiPaginationItem-root {
    color: ${COLORS.text.primary};

    &:hover {
      background-color: ${COLORS.action.hover};
    }

    &.Mui-selected {
      background-color: ${COLORS.action.selected};
    }
  }
`

export const Pagination = createComponentWrapperWithRef<TablePaginationProps>(
  {
    mui: MuiPagination,
    nova: NovaBasePagination,
  },
  'Pagination',
)
